function errorCode(error: unknown): string {
  if (error && typeof error === "object" && "code" in error) {
    return String((error as { code?: unknown }).code ?? "").toLowerCase();
  }

  return "";
}

function errorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message.toLowerCase();
  }

  if (error && typeof error === "object" && "message" in error) {
    return String((error as { message?: unknown }).message ?? "").toLowerCase();
  }

  return String(error ?? "").toLowerCase();
}

export function isExpectedAuthenticationError(error: unknown): boolean {
  const code = errorCode(error);
  const message = errorMessage(error);

  return (
    [
      "auth/invalid-credential",
      "auth/user-not-found",
      "auth/wrong-password",
      "auth/missing-password",
      "auth/invalid-email",
      "functions/unauthenticated",
    ].includes(code) ||
    message.includes("incorrect password or username") ||
    message.includes("invalid username or password")
  );
}

export function isConnectivityError(error: unknown): boolean {
  const code = errorCode(error);
  const message = errorMessage(error);

  return (
    [
      "auth/network-request-failed",
      "functions/unavailable",
      "unavailable",
    ].includes(code) ||
    message.includes("network-request-failed") ||
    message.includes("network error") ||
    message === "connection failed." ||
    message === "connection failed" ||
    message === "failed to fetch"
  );
}

export function shouldReportError(error: unknown): boolean {
  return (
    !isExpectedAuthenticationError(error) &&
    !isConnectivityError(error)
  );
}
